module.exports = __webpack_public_path__ + "static/media/Harmonizer Modeler Low Gain VR.97c84f9.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/modeler/Harmonizer Modeler Low Gain VR.mp3
// module id = yvNO
// module chunks = 12